(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const authorSection = document.getElementById('ArticleAuthor');
    if (!authorSection) return;

    function setAuthorSectionHeight() {
      const mainElement = document.querySelector('main');
      if (!mainElement) return;

      const currentSection = authorSection.closest('[id*="shopify-section"]');
      if (!currentSection) return;

      const allSections = Array.from(mainElement.querySelectorAll('[id*="shopify-section"]'));
      const currentIndex = allSections.indexOf(currentSection);

      if (currentIndex === -1 || allSections.length <= 1) return;

      let totalHeight = 0;
      authorSection.style.height = 'auto';

      // Calculate height from current section onwards
      for (let i = currentIndex; i < allSections.length; i++) {
        const section = allSections[i];

        // Stop if we reach full width sections like blog sliders or product sliders
        if (section.id.includes('slider') || section.id.includes('complementary')) {
          break;
        }

        totalHeight += section.offsetHeight;
      }

      // Set the height on the author section
      authorSection.classList.add('absolute', 'desktop:w-grid', 'h-full', '[--columns:4]');
      authorSection.style.height = `${totalHeight}px`;
    }

    // Debounce function
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    const debouncedResize = debounce(setAuthorSectionHeight, 150);
    window.addEventListener('resize', debouncedResize);
    window.addEventListener('load', setAuthorSectionHeight);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Update the width of lines under tabs based on their parent container's scrollable width.
     * This is necessary to ensure the line spans the full width of the tab content, whilst also not spanning the full viewport width.
     */
    const updateLines = () => {
      const lines = document.querySelectorAll('[data-details-line]');
      lines.forEach(line => {
        const parent = line.parentElement;
        if (parent)
          line.style.width = `calc(${
            parent.scrollWidth || parent.offsetWidth
          }px - var(--spacing-offset) * 3)`;
      });
    };

    // Initial update and on resize
    updateLines();
    window.addEventListener('resize', updateLines);
  })();

  } catch(e) { console.error(e); }
})();
})();
